"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_HATA_METNI = exports.API_HATA_SINIFLARI = void 0;
exports.apiHataMetni = apiHataMetni;
/**
 * D2 — SIZDIRMAZ HATA DİLİ: SUNUCU ARIZASININ EKRAN METNİ (madde 240 /
 * bulgu 71, 15.09.2026).
 *
 * Kural ekseni hataları (4xx) sunucuda D2 diliyle üretilir ve ekrana AYNEN
 * iner — kullanıcıya ne yapacağını söylerler. Beklenmeyen arızanın (5xx)
 * gövdesi ise çerçevenin HAM metnidir (*"Internal server error"*): iç dildir,
 * kullanıcı kendi hatası mı sistem arızası mı ayırt edemez ve girdiğini
 * kaybettiğini sanar (§2.40). Bu yüzden 5xx gövdesi ekrana hiç taşınmaz;
 * yerine buradaki metin gösterilir.
 *
 * ⚠️ TEK KAYNAK: web istemcisi (`apps/web/src/api/client.ts`) bu haritayı
 * okur; ekranda ikinci bir "sunucu hatası" cümlesi yazılmaz.
 */
exports.API_HATA_SINIFLARI = ['sunucu', 'baglanti'];
exports.API_HATA_METNI = {
    sunucu: 'İşlem kaydedilemedi (sistem hatası). Tekrar deneyin; sürerse sistem yöneticisine bildirin.',
    /**
     * ✏️ KA-5 (küçük A paketi / bulgu 74): istek sunucuya HİÇ ulaşmadı ya da yanıt
     * yarıda kesildi — `fetch` reddedilir ve tarayıcının ham metni (*"Load
     * failed"* · *"Failed to fetch"*) ekrana inerdi. Gözlem söylenir, sebep
     * tahmin edilmez (KA-1).
     */
    baglanti: 'Sunucuya bağlanılamadı. Bağlantınızı kontrol edip tekrar deneyin.',
};
/**
 * Yanıt durumuna göre KULLANICIYA gösterilecek metin. 5xx'te sunucunun
 * gövdesi YOK SAYILIR; 4xx'te sunucunun D2 mesajı geçer (yoksa `null` —
 * çağıran kendi bağlam metnini koyar).
 */
function apiHataMetni(status, sunucuMesaji) {
    if (status >= 500)
        return exports.API_HATA_METNI.sunucu;
    return sunucuMesaji ?? null;
}
//# sourceMappingURL=api-hata.js.map